module.exports = __webpack_public_path__ + "static/media/kredyt_24.8a22015a.png";